import { List as ImmutableList, Map as ImmutableMap, Record } from 'immutable';
import { INTERACTIVE_CARD_RESPONSE_MESSAGE } from '../constants/messageTypes';
import { SIMPLE } from '../../common-message-format/constants/contentTypes';
import { NOT_DELETED } from '../../common-message-format/constants/messageDeleteStatus';
import Status from '../../common-message-format/records/Status';
import { buildSendersFromLegacySender } from '../../senders/operators/buildSendersFromLegacySender';
class InteractiveCardResponseMessage extends Record({
  '@type': INTERACTIVE_CARD_RESPONSE_MESSAGE,
  ablyTs: null,
  attachments: ImmutableList(),
  cardInstanceId: null,
  cardType: null,
  channelInstanceId: null,
  clientType: null,
  contentType: SIMPLE,
  context: ImmutableMap(),
  direction: '',
  directReplyToMessageId: null,
  echo: null,
  errorReason: null,
  genericChannelId: null,
  hiddenBy: null,
  id: null,
  inReplyToId: null,
  integrationAppId: null,
  messageDeletedStatus: NOT_DELETED,
  recipients: ImmutableList(),
  richText: '',
  sender: ImmutableMap(),
  senders: ImmutableList(),
  status: Status(),
  text: '',
  timestamp: null
}, 'InteractiveCardResponseMessage') {
  constructor(props) {
    var _senderProps$context;
    const senderProps = props && buildSendersFromLegacySender(props);
    const superProps = senderProps ? Object.assign({}, senderProps, {
      context: ImmutableMap((_senderProps$context = senderProps.context) !== null && _senderProps$context !== void 0 ? _senderProps$context : {})
    }) : undefined;
    super(superProps);
  }
}
export default InteractiveCardResponseMessage;